import { render, staticRenderFns } from "./CommentAlertV.vue?vue&type=template&id=26d123c2&scoped=true&"
import script from "./CommentAlertV.vue?vue&type=script&lang=js&"
export * from "./CommentAlertV.vue?vue&type=script&lang=js&"
import style0 from "./CommentAlertV.vue?vue&type=style&index=0&id=26d123c2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d123c2",
  null
  
)

export default component.exports